import React, { FC, useEffect } from 'react';
import { Select, MenuItem, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IProps {
    languageDatas?: any;
}

export const SCUIGeneralLanguageSelect: FC<IProps> = ({ languageDatas }) => {
    const [language, setLanguage] = React.useState(1);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        setTimeout(() => {
            const tempLanguage = localStorage.getItem('lan') === 'undefined' ? '' : localStorage.getItem('lan') || '';
            const countryDataStr: any = localStorage.getItem('countryData');
            const countryData = JSON.parse(countryDataStr);
            const defaultLanguageCode = countryData.boSupportedLanguages?.find((l: any) => l.isDefault);
            const tempLanguageObject: any =
                localStorage.getItem('languageObject') === 'undefined'
                    ? ''
                    : localStorage.getItem('languageObject') || '';
            const isLanguageSet = tempLanguage && tempLanguageObject;
            const token =
                localStorage.getItem('access_token') === 'undefined' ? '' : localStorage.getItem('access_token') || '';
            if (!token) return;
            if (!isLanguageSet) {
                let selectedLang = languageDatas?.find((v: any) => v.languageId === +defaultLanguageCode?.languageId);
                localStorage.setItem('lan', selectedLang?.languageCode as string);
                localStorage.setItem('languageObject', JSON.stringify(selectedLang));

                setLanguage(
                    selectedLang?.languageId || languageDatas?.find((item: any) => item.isDefault === true)?.languageId
                );

                i18n.changeLanguage(
                    selectedLang?.languageCode ||
                        languageDatas?.find((item: any) => item.isDefault === true)?.languageCode
                );
            } else {
                let selectedLang = languageDatas?.find((v: any) => v.languageCode === tempLanguageObject?.languageCode);
                setLanguage(
                    JSON.parse(tempLanguageObject)?.languageId ||
                        selectedLang?.languageId ||
                        languageDatas?.find((item: any) => item.isDefault === true)?.languageId
                );

                i18n.changeLanguage(
                    JSON.parse(tempLanguageObject)?.languageCode ||
                        selectedLang?.value ||
                        languageDatas?.find((item: any) => item.isDefault === true)?.languageCode
                );
            }
        }, 1000);
    }, [languageDatas]);

    const handleChange = (_: any, dataset: any) => {
        const langCode = dataset.props['data-code'];

        let selectedLang = languageDatas?.find((v: any) => v.languageCode === langCode);
        localStorage.setItem('lan', selectedLang?.value as string);
        localStorage.setItem('languageObject', JSON.stringify(selectedLang));

        i18n.changeLanguage(langCode);
        setLanguage(selectedLang?.languageId);

        window.location.reload();
    };

    return (
        <div className="sideBySideDiv">
            <div className="regionSelect" style={{ marginTop: '1rem' }}>
                {`${t('general.language')}:`}
            </div>
            <Select variant="standard" value={language} onChange={handleChange} disableUnderline>
                {languageDatas &&
                    languageDatas.map((option: any, index: any) => (
                        <MenuItem
                            key={index}
                            value={option.languageId}
                            data-code={option.languageCode}
                            data-src={option.flagUrl}
                        >
                            <div className="sideBySideDiv">
                                <Avatar
                                    src={option.flagUrl}
                                    alt={option.languageName}
                                    sx={{
                                        width: 15,
                                        height: 15,
                                        marginRight: 0.8,
                                        marginTop: '0.3rem',
                                    }}
                                />
                                <p style={{ marginTop: '0.5rem' }}>{option.languageName}</p>
                            </div>
                        </MenuItem>
                    ))}
            </Select>
        </div>
    );
};
